import React from 'react';
import './style.scss';
import Tab from 'components/Tab';

const MenuBar = ({ activeMap, onMapChange }) => {
  const menuItems = [
    { id: 'tang-tret', label: 'Tầng trệt' },
    { id: 'khoi-podium', label: 'Khối podium' },
    { id: 'rooftop', label: 'Rooftop' },
  ];

  const activeIndex = menuItems.findIndex((item) => item.id === activeMap);
  const selectedValue = { value: activeMap, index: activeIndex };

  const handleTabChange = ({ value }) => {
    onMapChange(value);
  };

  return (
    <div className="menu-bar">
      <Tab onTabChange={handleTabChange} value={selectedValue}>
        <Tab.List>
          {menuItems.map((item, index) => (
            <Tab.Item key={item.id} value={item.id} index={index}>
              {item.label}
            </Tab.Item>
          ))}
        </Tab.List>
      </Tab>
    </div>
  );
};

export default MenuBar;
